export default __webpack_public_path__ + "static/media/conteudo_extra_06_18.c7e06ade.jpg";